<template>
  <div class="viq-tl-event" :class="{ 'viq-tl-event--last': isLast }">
    <div class="viq-tl-event__dot" :class="'viq-tl-event__dot--' + statusClass" />
    <div class="viq-tl-event__card">
      <div class="viq-tl-event__date">{{ formatDate(event.date) }}</div>
      <h4 class="viq-tl-event__title">{{ event.title || event.description }}</h4>
      <p v-if="event.description && event.title" class="viq-tl-event__desc">
        {{ event.description }}
      </p>
      <div class="viq-tl-event__meta">
        <span v-if="event.status" class="viq-tl-event__status" :class="'viq-tl-event__status--' + statusClass">
          {{ event.status }}
        </span>
        <span v-if="event.jurisdiction" class="viq-tl-event__jurisdiction">
          {{ event.jurisdiction }}
        </span>
        <span v-if="event.type" class="viq-tl-event__type">{{ event.type }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViqTimelineEvent",
  props: {
    event: {
      type: Object,
      required: true,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statusClass() {
      const s = (this.event.status || "").toLowerCase();
      if (s.includes("complete") || s.includes("enacted") || s.includes("effective")) return "complete";
      if (s.includes("progress") || s.includes("pending") || s.includes("draft")) return "pending";
      if (s.includes("upcoming") || s.includes("proposed")) return "upcoming";
      return "default";
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "TBD";
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-tl-event {
  position: relative;
  padding-bottom: $viq-space-lg;

  &--last {
    padding-bottom: 0;
  }

  &__dot {
    position: absolute;
    left: -25px;
    top: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid $viq-bg-primary;
    z-index: 1;

    &--complete {
      background: $viq-success;
    }
    &--pending {
      background: $viq-warning;
    }
    &--upcoming {
      background: $viq-accent;
    }
    &--default {
      background: $viq-text-secondary;
    }
  }

  &__card {
    padding: $viq-space-md;
    background: $viq-bg-primary;
    border: 1px solid $viq-border;
    border-radius: $viq-radius-md;
    transition: box-shadow $viq-transition-fast;

    &:hover {
      box-shadow: $viq-shadow-sm;
    }
  }

  &__date {
    font-size: $viq-font-xs;
    font-weight: 700;
    color: $viq-accent;
    margin-bottom: $viq-space-xs;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  &__title {
    font-size: $viq-font-base;
    font-weight: 700;
    color: $viq-text-primary;
    margin: 0 0 $viq-space-xs;
    line-height: 1.4;
  }

  &__desc {
    font-size: $viq-font-sm;
    color: $viq-text-secondary;
    margin: 0 0 $viq-space-sm;
    line-height: 1.5;
  }

  &__meta {
    display: flex;
    flex-wrap: wrap;
    gap: $viq-space-sm;
  }

  &__status {
    padding: 2px 8px;
    border-radius: $viq-radius-full;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;

    &--complete {
      background: rgba(16, 185, 129, 0.1);
      color: $viq-success;
    }
    &--pending {
      background: rgba(245, 158, 11, 0.1);
      color: $viq-warning;
    }
    &--upcoming {
      background: rgba(37, 99, 235, 0.1);
      color: $viq-accent;
    }
    &--default {
      background: $viq-bg-secondary;
      color: $viq-text-secondary;
    }
  }

  &__jurisdiction,
  &__type {
    font-size: 10px;
    color: $viq-text-secondary;
    font-weight: 500;
  }
}
</style>
